import React, { ReactElement } from 'react';
import { Drawer as AntDrawer, DrawerProps } from 'antd';

export const Drawer = ({ ...rest }: DrawerProps): ReactElement => (
   <AntDrawer
     width='500px'
     {...rest}
   />
);
